import Mediator from "../../Utilities/Mediator";

export function showProgress(end: number, forward: boolean) {
	let spans: NodeListOf<HTMLSpanElement> = document.querySelectorAll('.create-order > div:nth-child(2) span');
	if (forward) {
		spans.forEach((s, i) => {
			if (i < end) {
				s.classList.add('progress--checked');
			}
		});
	} else {
		spans.forEach((s, i) => {
			s.classList.remove('progress--checked');
			if (i < end) {
				s.classList.add('progress--checked');
			}
		});
	}
}

export function openComboItemWarningModal(isNext: boolean) {
	const modal: HTMLDivElement = document.querySelector("#combo-service-error-modal");
	modal.style.display = "flex";
	addComboItemWarningModalButtonsClickListener(modal, isNext);
}

function addComboItemWarningModalButtonsClickListener(modal: HTMLDivElement, isNext: boolean) {
	const closeImg: HTMLImageElement = modal.querySelector('img[alt="close icon"]');
	closeImg.onclick = () => {
		modal.style.display = "none";
	}

	const cancelButton: HTMLButtonElement = modal.querySelector("button");
	cancelButton.onclick = () => {
		modal.style.display = "none";
	}

	const okButton: HTMLButtonElement = modal.querySelector("button + button");
	okButton.onclick = () => {
		if (isNext) {
			Mediator.emit("finalizeBillDispatched");
		} else {
			Mediator.emit("chooseItemDispatched");
		}
		modal.style.display = "none";
	}
}
